<template>
  <section>
    <b-card no-body>
      <b-tabs>
        <b-tab title="CAR" active>
          <b-card-title align="center">Corrective Action Report (CAR)</b-card-title>
          <b-card-text>
            <p>Section #2 response required within 72 hours of receipt. Section #4 response require within 15 business
              days.</p>
            <b-row>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="CAR #">
                  <b-form-input disabled v-model="formData.id"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Date Rejected">
                  <date-picker :config="datePickerOptions" v-model="formData.rejectDate"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Customer's PO#">
                  <b-form-input disabled :value="formData.purchaseOrderId"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Invoice #">
                  <b-form-input disabled :value="formData.invoiceId"/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Customer">
                  <b-form-input disabled :value="headerData.customerName"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Date">
                  <b-form-input disabled :value="dateFilter(headerData.dateCreated)"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Part Number">
                  <b-form-input disabled :value="headerData.partNumber"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Quantity">
                  <b-form-input type="number" v-model="formData.quantity"/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
        <b-tab title="SCAR">
          <b-card-title align="center">Supplier Corrective Action Report (SCAR)</b-card-title>
          <b-card-text>
            <p>Section #2 response required within 72 hours of receipt. Section #4 response require within 15 business
              days.</p>
            <b-row>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="SCAR #">
                  <b-form-input disabled v-model="formData.id"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Date Rejected">
                  <date-picker :config="datePickerOptions" v-model="formData.rejectDate"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Customer's PO#">
                  <b-form-input disabled :value="formData.purchaseOrderId"/>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Supplier">
                  <b-form-input disabled :value="headerData.vendorName"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Date">
                  <b-form-input disabled :value="dateFilter(headerData.dateCreated)"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Part Number">
                  <b-form-input disabled :value="headerData.partNumber"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label-cols="3" label-align="right" label="Quantity">
                  <b-form-input type="number" v-model="formData.quantity"/>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </b-card>
    <!--color="gray"-->
    <form-wizard
      shape="tab"
      color="#3498db"
      @on-complete="onWizardComplete"
      :start-index="activeTabIndex"
    >
      <tab-content title="Section 1" icon="fa fa-building">
        <b-card>
          <template v-slot:header>
            <h6 class="mb-0 text-center">Section 1: Non-Conformance Description</h6>
          </template>
          <b-card-text>
            <b-form-group>
              <b-form-textarea rows="5" max-rows="8" v-model="formData.section1"
                               placeholder="Enter the description of the non-conformance"/>
            </b-form-group>
          </b-card-text>
        </b-card>
      </tab-content>
      <tab-content title="Section 2" icon="fa fa-truck">
        <b-card>
          <template v-slot:header>
            <h6 class="mb-0 text-center">Section 2: Define the fix (Containment Action)</h6>
          </template>
          <b-card-text>
            <b-form-group>
              <b-form-textarea rows="5" v-model="formData.section2"
                               placeholder="Enter the action performed to prevent the problem from occuring in the future"
                               max-rows="8"/>
            </b-form-group>
          </b-card-text>
        </b-card>
      </tab-content>
      <tab-content title="Section 3" icon="fa fa-handshake-o">
        <b-card>
          <template v-slot:header>
            <h6 class="mb-0 text-center">Section 3: Root Cause</h6>
          </template>
          <b-card-text>
            <b-form-group>
              <b-form-textarea rows="5" v-model="formData.section3"
                               placeholder="Describe the circumstances that caused the non-conformance" max-rows="8"/>
            </b-form-group>
          </b-card-text>
        </b-card>
      </tab-content>
      <tab-content title="Section 4" icon="fa fa-quote-left">
        <b-card>
          <template v-slot:header>
            <h6 class="mb-0 text-center">Section 4: Supplier's Corrective Action taken to prevent the reoccurance</h6>
          </template>
          <b-card-text>
            <b-form-group>
              <b-form-textarea rows="5" max-rows="8" v-model="formData.section4"
                               placeholder="Describe the actions the supplier is taking to prevent a reoccurance"/>
            </b-form-group>
          </b-card-text>
        </b-card>
      </tab-content>
      <tab-content title="Section 5" icon="fa fa-credit-card">
        <b-card>
          <template v-slot:header>
            <h6 class="mb-0 text-center">Section 5: Verification of effectiveness</h6>
          </template>
          <b-card-text>
            <b-form-group>
              <b-form-textarea rows="5" max-rows="8" v-model="formData.section5"
                               placeholder="Describes the actions that will be taken to verify the effectiveness of the corrective action."/>
            </b-form-group>
          </b-card-text>
        </b-card>
      </tab-content>
      <tab-content title="Signatures " icon="fa fa-file-text-o">
        <b-card>
          <template v-slot:header>
            <h6 class="mb-0 text-center">Signatures</h6>
          </template>
          <b-card-text>
            <h6>Product Engineer</h6>
            <b-row>
              <b-col cols="3">
                <b-form-group label-cols="3" label="Name">
                  <b-form-input @input="productEngineerChanged=true, draw('productEngineerSignatureBase64',$event)" v-model="formData.productEngineerName"/>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-radio-group :options="[{ text: 'Approved', value: true },{ text: 'Rejected', value: false }]"
                                    v-model="formData.productEngineerApproved"/>
              </b-col>
              <b-col cols="2">
                <b-form-group>
                  <date-picker :config="datePickerOptions" v-model="formData.productEngineerDate"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <img :height="50" :width="500" v-if="!productEngineerChanged && formData.productEngineerSignature" v-bind:src="`data:image/png;base64,${formData.productEngineerSignature}`" />
                <canvas
                  v-if="productEngineerChanged"
                  id="productEngineerSignatureBase64"
                  :height="50"
                  :width="500"
                />
              </b-col>
            </b-row>
            <h6>Supplier Quality Assurance</h6>
            <b-row>
              <b-col cols="3">
                <b-form-group label-cols="3" label="Name">
                  <b-form-input @input="supplierQAChanged=true, draw('supplierQASignatureBase64',$event)" v-model="formData.supplierQAName"/>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-radio-group :options="[{ text: 'Approved', value: true },{ text: 'Rejected', value: false }]" v-model="formData.supplierQAApproved"/>
              </b-col>
              <b-col cols="2">
                <b-form-group>
                  <date-picker :config="datePickerOptions" v-model="formData.supplierQADate"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <img :height="50" :width="500" v-if="!supplierQAChanged && formData.supplierQASignature" v-bind:src="`data:image/png;base64,${formData.supplierQASignature}`" />
                <canvas
                  v-if="supplierQAChanged"
                  id="supplierQASignatureBase64"
                  :height="50"
                  :width="500"
                />
              </b-col>
            </b-row>
            <h6>Supplier Quality Director</h6>
            <b-row>
              <b-col cols="3">
                <b-form-group label-cols="3" label="Name">
                  <b-form-input @input="supplierDirectorChanged=true, draw('supplierDirectorSignatureBase64',$event)" v-model="formData.supplierDirectorName"/>
                </b-form-group>
              </b-col>
              <b-col cols="2">
                <b-form-radio-group :options="[{ text: 'Approved', value: true },{ text: 'Rejected', value: false }]" v-model="formData.supplierDirectorApproved"/>
              </b-col>
              <b-col cols="2">
                <b-form-group>
                  <date-picker :config="datePickerOptions" v-model="formData.supplierDirectorDate"/>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <img :height="50" :width="500" v-if="!supplierDirectorChanged && formData.supplierDirectorSignature" v-bind:src="`data:image/png;base64,${formData.supplierDirectorSignature}`" />
                <canvas
                  v-if="supplierDirectorChanged"
                  id="supplierDirectorSignatureBase64"
                  :height="50"
                  :width="500"
                />
              </b-col>
            </b-row>
          </b-card-text>
          <template v-slot:footer>
            <b>Note: Signatures with an approved checkmark represent approval of supplier's Corrective Action Plan
              (Section #4)</b>
          </template>
        </b-card>
      </tab-content>
      <template slot="footer" scope="props">
        <div class="wizard-footer-left" v-if="formData.id">
          <wizard-button @click.native="closeReport" :style="props.fillButtonStyle" class="wizard-footer-center btn btn-primary mr-2">Close Report</wizard-button>
          <wizard-button @click.native="$emit('openReportModal')" :style="props.fillButtonStyle" class="wizard-footer-center mr-2">
            Print
          </wizard-button>
          <wizard-button @click.native="$emit('openEmailModal')" :style="props.fillButtonStyle" class="wizard-footer-center">Email</wizard-button>
        </div>
        <div class="wizard-footer-right" v-else>
          <wizard-button :disabled="isSaving" @click.native="saveAndContinue" class="wizard-footer-left" :style="props.fillButtonStyle">
            <i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i> Save & Continue</wizard-button>
        </div>
        <div class="wizard-footer-right" v-if="formData.id">
          <wizard-button @click.native="props.prevTab()" v-if="props.activeTabIndex" class="wizard-footer-left mr-2" :style="props.fillButtonStyle">Back</wizard-button>
          <wizard-button :disabled="isSaving" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">
            <i v-show="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>{{props.isLastStep ? 'Submit' : 'Next'}}</wizard-button>
        </div>
      </template>
    </form-wizard>
  </section>
</template>

<script>
  import Vue from 'vue';
  import { mapGetters, mapActions } from 'vuex';
  import { DATE_FORMAT } from '@/shared/constants';
  import VueFormWizard from 'vue-form-wizard2';
  import 'vue-form-wizard2/dist/vue-form-wizard.min.css';
  import { date } from '@/shared/filters';
  Vue.use(VueFormWizard);

  export default {
    props: {
      lineData: {
        type: Object,
        default: () => {
        },
      },
      reportDetails: {
        type: Object,
        default: () => {
        },
      },
      invoiceLineId: {
        type: [Number, String],
        default: 0,
      },
      purchaseOrderLineId: {
        type: [Number, String],
        default: 0,
      },
      otherData:{
        type: Object,
        default: () => {
        },
      }
    },
    data: () => ({
      activeTabIndex: 0,
      dateFilter: date,
      datePickerOptions: {
        format: DATE_FORMAT,
        useCurrent: true,
      },
      headerData:{},
      formData: {},
      isSaving: false,
      productEngineerChanged:false,
      supplierQAChanged:false,
      supplierDirectorChanged:false,
    }),
    computed: {},
    methods: {
      ...mapActions('carScarReports', ['manageCar']),
      async saveAndContinue(){
        try {
          this.isSaving = true;
          this.formData = {
            ...this.formData, rejectDate: new Date(this.formData.rejectDate).toISOString(),
            active: true,
          };
          const data = await this.manageCar(this.formData);
          if (data.id) {
            this.$emit('refreshGrid', data);
          }
          this.isSaving = false;
        } catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      },
      async onWizardComplete() {
        try {
          this.isSaving = true;
          this.formData = {
            ...this.formData,
            rejectDate: (this.formData.rejectDate != '') ? new Date(this.formData.rejectDate).toISOString() : '',
            productEngineerDate: (this.formData.rejectDate != '') ? new Date(this.formData.productEngineerDate).toISOString() : '',
            supplierQADate: (this.formData.rejectDate != '') ? new Date(this.formData.supplierQADate).toISOString() : '',
            supplierDirectorDate: (this.formData.rejectDate != '') ? new Date(this.formData.supplierDirectorDate).toISOString() : '',
            active: true,
          };
          const id = await this.manageCar(this.formData);
          this.isSaving = false;
          if (id) {
            this.$bvModal.hide('car-scar-modal');
            this.$emit('refreshGrid');
          }
        }catch (e) {
          this.isSaving = false;
          /*console.log(e.message);*/
        }
      },
      setFormData(){
        this.formData = {
          ...this.formData,
          id: this.reportDetails.id || 0,
          rejectDate: (this.reportDetails.rejectDate)?this.dateFilter(this.reportDetails.rejectDate) : new Date(),
          statusId: this.reportDetails.statusId,
          customerId: this.reportDetails.customerId || (this.invoiceLineId && this.otherData) ? this.otherData.companyId : 0, //add company id
          vendorId: this.reportDetails.vendorId || (this.purchaseOrderLineId)?this.lineData.companyId:0,
          invoiceId: this.reportDetails.invoiceId || (this.invoiceLineId) ? this.lineData.invoiceId : (this.purchaseOrderLineId) ? this.otherData.invoiceId : 0,
          invoiceLineId: this.reportDetails.invoiceLineId || this.invoiceLineId,
          purchaseOrderId: this.reportDetails.purchaseOrderId || ((this.invoiceLineId) ? this.lineData.customerPO : this.lineData.purchaseOrderId) || null,
          purchaseOrderLineId: this.reportDetails.purchaseOrderLineId || this.purchaseOrderLineId,
          partId: this.reportDetails.partId || this.lineData.partId || 0,
          quantity: this.reportDetails.quantity || this.lineData.quantity || 0,
          section1: this.reportDetails.section1 || '',
          section2: this.reportDetails.section2 || '',
          section3: this.reportDetails.section3 || '',
          section4: this.reportDetails.section4 || '',
          section5: this.reportDetails.section5 || '',
          productEngineerName: this.reportDetails.productEngineerName || '',
          productEngineerApproved: (this.reportDetails.id) ? this.reportDetails.productEngineerApproved : true,
          productEngineerDate: (this.reportDetails.productEngineerDate)?this.dateFilter(this.reportDetails.productEngineerDate) : new Date(),
          productEngineerSignature: this.reportDetails.productEngineerSignature || '',
          productEngineerSignatureBase64: this.reportDetails.productEngineerSignatureBase64 || '',
          supplierQAName: this.reportDetails.supplierQAName || '',
          supplierQAApproved: (this.reportDetails.id) ? this.reportDetails.supplierQAApproved : true,
          supplierQADate: (this.reportDetails.supplierQADate)?this.dateFilter(this.reportDetails.supplierQADate) : new Date(),
          supplierQASignature: this.reportDetails.supplierQASignature || '',
          supplierQASignatureBase64: this.reportDetails.supplierQASignatureBase64 || '',
          supplierDirectorName: this.reportDetails.supplierDirectorName || '',
          supplierDirectorApproved: (this.reportDetails.id) ? this.reportDetails.supplierDirectorApproved : true,
          supplierDirectorDate: (this.reportDetails.supplierDirectorDate)?this.dateFilter(this.reportDetails.supplierDirectorDate) : new Date(),
          supplierDirectorSignature: this.reportDetails.supplierDirectorSignature || '',
          supplierDirectorSignatureBase64: this.reportDetails.supplierDirectorSignatureBase64 || '',
        };

        this.headerData = {
          ...this.headerData,
          customerName: (this.invoiceLineId && this.otherData) ? this.otherData.companyName : (this.purchaseOrderLineId && this.otherData) ? this.otherData.companyName : '',
          vendorName: (this.purchaseOrderLineId) ? this.lineData.companyName : '',
          dateCreated: this.reportDetails.dateCreated || '',
          partNumber: this.lineData.partNumber,
        }
      },
      async closeReport(){
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to close this report`});
        if (deleteConfirmed) {
          await this.manageCar({...this.reportDetails,statusId: 406});
          this.$emit('refreshGrid');
        }
      },
      sendEmail() {
        this.$emit('openEmailModal',this.formData.id);
      },
      draw(canvasId,textVal) {
        setTimeout(()=>{
          const cv = document.getElementById(canvasId)
          const ctx = cv.getContext('2d')
          ctx.clearRect(0, 0, 500, 50)
          ctx.font = 36 + 'px' + ' Brush Script MT';
          if (true) {
            ctx.clearRect(0, 0, 500, 50)
          } else {
            ctx.fillStyle = this.backgroundColor
            ctx.fillRect(0, 0, 500, 50)
          }
          ctx.fillStyle = '#000000'
          ctx.textAlign = 'center'
          ctx.textBaseline = 'middle'
          ctx.save()
          ctx.translate(500 / 2, 50 / 2)
          //ctx.rotate(this.angle * Math.PI / 180)
          ctx.fillText(textVal, 0, 0)
          ctx.restore()
          this.formData[canvasId] = document.getElementById(canvasId).toDataURL('image/png');
          /*let base64Data = document.getElementById(canvasId).toDataURL('image/png');
          if(base64Data){
            this.formData[canvasId] = this.b64toBlob(document.getElementById(canvasId).toDataURL('image/png'));
          }*/
        },50)
      },
      b64toBlob(b64Data, sliceSize) {
        let block = b64Data.split(";");
        // Get the content type of the image
        let contentType = block[0].split(":")[1] || '';
        // get the real base64 content of the file
        b64Data = block[1].split(",")[1];

        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }
    },
    watch: {
      reportDetails(){
        this.setFormData();
      },
      lineData() {
        this.setFormData();
      },
    },
    mounted() {},
  };
</script>
